import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';
import { PedidoCadastro } from '../models/pedido-cadastro';
import { LocalStoreKeys } from '../shared/helpers/localstorage/local-store';
import { PedidoInfo } from '../models/pedido-info';
import { PedidoAlerta } from '../models/pedido-alerta';
import { Purchase, PurchaseResponse } from '../models/purchase';

@Injectable({
    providedIn: 'root'
})
export class PedidoDataService {

    private currentPedidoSubject: BehaviorSubject<PedidoCadastro>;
    private currentPurchaseSubject: BehaviorSubject<Purchase>;
    public currentPedido: Observable<PedidoCadastro>;
    public currentPurchase: Observable<Purchase>;

    constructor() {
        this.currentPedidoSubject = new BehaviorSubject<PedidoCadastro>(JSON.parse(localStorage.getItem(LocalStoreKeys.currentOrder)));
        this.currentPedido = this.currentPedidoSubject.asObservable();
        // pedidoInfo
        this.currentPedidoInfoSubject = new BehaviorSubject<PedidoInfo>(JSON.parse(localStorage.getItem(LocalStoreKeys.currentPedidoInfo)));
        this.currentPedidoInfo = this.currentPedidoInfoSubject.asObservable();
        // purchaseInfo
        this.currentPurchaseInfoSubject = new BehaviorSubject<Purchase>(JSON.parse(localStorage.getItem(LocalStoreKeys.currentPurchaseInfo)));
        this.currentPurchaseInfo = this.currentPurchaseInfoSubject.asObservable();
        // purchasePayment
        this.currentPurchasePaymentSubject = new BehaviorSubject<PurchaseResponse>(JSON.parse(localStorage.getItem(LocalStoreKeys.currentPurchasePayment)));
        this.currentPurchasePayment = this.currentPurchasePaymentSubject.asObservable();
        // pedidoAlerta
        this.currentPedidoAlertaSubject = new BehaviorSubject<PedidoAlerta>(JSON.parse(localStorage.getItem(LocalStoreKeys.currentPedidoAlerta)));
        this.currentPedidoAlerta = this.currentPedidoAlertaSubject.asObservable();
        this.currentPurchaseSubject = new BehaviorSubject<Purchase>(JSON.parse(localStorage.getItem(LocalStoreKeys.currentPurchase)));
        this.currentPurchase = this.currentPurchaseSubject.asObservable();
    }

    //#region pedidoInfo
    private currentPedidoInfoSubject: BehaviorSubject<PedidoInfo>;
    public currentPedidoInfo: Observable<PedidoInfo>;
    //#endregion

    //#region purchaseInfo
    private currentPurchaseInfoSubject: BehaviorSubject<Purchase>;
    public currentPurchaseInfo: Observable<Purchase>;
    //#endregion

    //#region purchaseInfo
    private currentPurchasePaymentSubject: BehaviorSubject<PurchaseResponse>;
    public currentPurchasePayment: Observable<PurchaseResponse>;
    //#endregion

    //#region pedidoAlerta
    private currentPedidoAlertaSubject: BehaviorSubject<PedidoAlerta>;
    public currentPedidoAlerta: Observable<PedidoAlerta>;
    //#endregion

    public get currentPedidoValue(): PedidoCadastro {
        return this.currentPedidoSubject.value;
    }
    public get currentPurchaseValue(): Purchase{
        return this.currentPurchaseSubject.value;
    }
    
    setCurrentPurchaseValue(purchase: Purchase){
        localStorage.setItem(LocalStoreKeys.currentPurchase, JSON.stringify(purchase));
        this.currentPurchaseSubject.next(purchase);
    }

    setCurrentPedidoValue(pedidoCadastro: PedidoCadastro) {
        localStorage.setItem(LocalStoreKeys.currentOrder, JSON.stringify(pedidoCadastro));
        this.currentPedidoSubject.next(pedidoCadastro);
    }

    deleteCurrentPedidoValue() {
        localStorage.removeItem(LocalStoreKeys.currentOrder);
        this.currentPedidoSubject.next(null);
    }
    
    deleteCurrentPurchaseValue() {
        localStorage.removeItem(LocalStoreKeys.currentPurchase);
        this.currentPurchaseSubject.next(null);
    }

    //#region pedidoInfo
    public get currentPedidoInfoValue(): PedidoInfo {
        return this.currentPedidoInfoSubject.value;
    }

    setCurrentPedidoInfoValue(pedidoInfo: PedidoInfo) {
        localStorage.setItem(LocalStoreKeys.currentPedidoInfo, JSON.stringify(pedidoInfo));
        this.currentPedidoInfoSubject.next(pedidoInfo);
    }

    public get currentPurchaseInfoValue(): Purchase {
        return this.currentPurchaseInfoSubject.value;
    }

    setCurrentPurchaseInfoValue(purchaseInfo: Purchase) {
        localStorage.setItem(LocalStoreKeys.currentPurchaseInfo, JSON.stringify(purchaseInfo));
        this.currentPurchaseInfoSubject.next(purchaseInfo);
    }

    deleteCurrentPedidoInfoValue() {
        localStorage.removeItem(LocalStoreKeys.currentPedidoInfo);
        this.currentPedidoInfoSubject.next(null);
    }

    deleteCurrentPurchaseInfoValue() {
        localStorage.removeItem(LocalStoreKeys.currentPurchaseInfo);
        this.currentPurchaseInfoSubject.next(null);
    }
    //#endregion

    //#region pedidoAlerta
    public get currentPedidoAlertaValue(): PedidoAlerta {
        return this.currentPedidoAlertaSubject.value;
    }

    setCurrentPedidoAlertaValue(pedidoAlerta: PedidoAlerta) {
        localStorage.setItem(LocalStoreKeys.currentPedidoAlerta, JSON.stringify(pedidoAlerta));
        this.currentPedidoAlertaSubject.next(pedidoAlerta);
    }

    deleteCurrentPedidoAlertaValue() {
        localStorage.removeItem(LocalStoreKeys.currentPedidoAlerta);
        this.currentPedidoAlertaSubject.next(null);
    }
    //#endregion

    public get currentPurchasePaymentValue(): PurchaseResponse {
        return this.currentPurchasePaymentSubject.value;
    }

    setCurrentPurchasePaymentValue(purchasePayment: PurchaseResponse) {
        localStorage.setItem(LocalStoreKeys.currentPurchasePayment, JSON.stringify(purchasePayment));
        this.currentPurchasePaymentSubject.next(purchasePayment);
    }

    deleteCurrentPurchasePaymentValue() {
        localStorage.removeItem(LocalStoreKeys.currentPurchasePayment);
        this.currentPurchasePaymentSubject.next(null);
    }
}